<template>
  <div class="survey__begin__start">
    <h1 class="medium survey__begin__title">
      {{ customSurvey.title }}
    </h1>
    <h4 class="regular survey__begin__description">
      {{ customSurvey.description }}
    </h4>

    <div class="row mt-4 mb-4">
      <div class="col">
        <b-button
          v-if="!customSurvey.questions || !customSurvey.questions.length"
          class="btn-block survey-begin flex"
          variant="secondary"
          :disabled="true"
        >
          <loading-state />
        </b-button>

        <b-button
          v-else
          @click="begin"
          class="btn-block survey-begin"
          variant="secondary"
          id="btn-survey-begin"
          ref="btnSurveyBegin"
          tabindex="1"
          :title="resources.general.buttons.startAccessibility"
        >
          {{ resources.general.buttons.start }}
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    'loading-state': () => import('@/components/Shared/Loading.vue'),
  },
  computed: {
    ...mapGetters({
      customSurvey: 'customSurvey/customSurvey',
      resources: 'resources',
    }),
  },
  watch: {
    survey() {
      this.$nextTick(() => {
        this.$refs.btnSurveyBegin.focus()
      })
    },
  },
  methods: {
    begin() {
      this.$router.push({ name: 'custom-surveys.survey.steps' })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

h5 {
  padding-top: 1.5rem;

  @media (max-width: 767px) {
    padding-top: 0;
    font-size: 14px;
  }
}

.survey-begin {
  max-width: 380px;
  margin: 0 auto;

  &.flex {
    display: flex;
    justify-content: center;
    align-items: center;

    /deep/ .lds-ellipsis {
      transform: translateY(-14px);
    }
  }
}
</style>
